document.addEventListener('DOMContentLoaded', function () {
	const grid = document.getElementById('product-grid');
	const loader = document.getElementById('infinite-scroll-loader');
	if (!grid || !loader) return;

	let currentPage = parseInt(grid.dataset.currentPage, 10);
	const totalPages = parseInt(grid.dataset.totalPages, 10);
	const baseUrl = grid.dataset.collectionUrl;
	let loading = false;
	let prefetchedPage = null;
	let prefetchedRequest = null;

	const getNextPageUrl = function (nextPage) {
		const url = new URL(baseUrl, window.location.origin);
		const currentQuery = new URLSearchParams(window.location.search);
		currentQuery.forEach(function (value, key) {
			url.searchParams.set(key, value);
		});
		url.searchParams.set('page', nextPage);
		url.searchParams.set('section_id', grid.dataset.id);
		return url.toString();
	};

	const fetchPage = function (page) {
		if (prefetchedPage === page && prefetchedRequest) return prefetchedRequest;

		prefetchedPage = page;
		prefetchedRequest = fetch(getNextPageUrl(page), { credentials: 'same-origin' })
			.then(function (response) {
				if (!response.ok) throw new Error('Unable to load more products.');
				return response.text();
			})
			.catch(function (error) {
				prefetchedPage = null;
				prefetchedRequest = null;
				throw error;
			});
		return prefetchedRequest;
	};

	const prefetchNextPage = function () {
		const nextPage = currentPage + 1;
		if (nextPage > totalPages || prefetchedPage === nextPage) return;
		fetchPage(nextPage).catch(function () {
			// The regular loader will retry if the customer reaches the end of the grid.
		});
	};

	const loadMore = function () {
		if (loading || currentPage >= totalPages) return;
		loading = true;
		loader.style.display = 'block';

		const nextPage = currentPage + 1;
		fetchPage(nextPage)
			.then(function (html) {
				const doc = new DOMParser().parseFromString(html, 'text/html');
				const newItems = doc.querySelectorAll('#product-grid > li');
				if (!newItems.length) throw new Error('No additional products were returned.');

				newItems.forEach(function (item) {
					grid.appendChild(item);
				});

				currentPage = nextPage;
				grid.dataset.currentPage = currentPage;
				prefetchedPage = null;
				prefetchedRequest = null;
				if (currentPage >= totalPages) {
					loader.style.display = 'none';
					observer.disconnect();
				} else {
					schedulePrefetch();
				}
			})
			.catch(function (error) {
				console.error(error);
				loader.style.display = 'none';
			})
			.finally(function () {
				loading = false;
			});
	};

	const observer = new IntersectionObserver(function (entries) {
		if (entries.some(function (entry) { return entry.isIntersecting; })) {
			loadMore();
		}
	}, { rootMargin: '1600px 0px' });

	observer.observe(loader);

	const schedulePrefetch = function () {
		if ('requestIdleCallback' in window) {
			window.requestIdleCallback(prefetchNextPage, { timeout: 3000 });
		} else {
			window.setTimeout(prefetchNextPage, 1500);
		}
	};

	schedulePrefetch();
});
